var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('img',{staticClass:"bg_img",attrs:{"src":require(`@/static/image/index/warn.png`),"alt":""}}),_vm._v(" "+_vm._s(_vm.agentTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }